import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

const ReCaptcha = ({ onVerify }) => {
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

  const handleChange = (token) => {
    onVerify(token ? true : false);
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
      <ReCAPTCHA sitekey={siteKey} onChange={handleChange} />
    </div>
  );
};

export default ReCaptcha;